<template>
  <div class="elencomarcheedit">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Modifica un costruttore</h5>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col cols="12" md="12">
          <b-form-input class="slide-up" id="denominazione" v-model="formData.costruttore.denominazione" type="text" :state="state.denominazione" placeholder="Denominazione del costruttore" /><label for="denominazione">* Denominazione</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cf" v-model="formData.costruttore.cf" type="text" :state="state.cf" placeholder="Codice fiscale del costruttore" /><label for="cf">Codice Fiscale</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="piva" v-model="formData.costruttore.piva" type="text" :state="state.piva" placeholder="Partita IVA del costruttore" /><label for="piva">Partita IVA</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>REFERENTE</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cont1" v-model="formData.costruttore.cont1" type="text" :state="state.cont1" placeholder="Contatto principale del costruttore" /><label for="cont1">Principale</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cont2" v-model="formData.costruttore.cont2" type="text" :state="state.cont2" placeholder="Contatto secondario del costruttore" /><label for="cont2">Secondario</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>SEDE OPERATIVA</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" offset-md="1" md="10">
          <b-form-input id="search_box" type="search" placeholder="Seleziona il tuo indirizzo" :state="state.search_address" autocomplete="off"></b-form-input>
          <div id="ubicazione_map"></div>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>ALTRE INFORMAZIONI</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="website" v-model="formData.costruttore.website" type="text" :state="state.website" placeholder="Sito web del costruttore" /><label for="website">Sito web</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="email" v-model="formData.costruttore.email" type="text" :state="state.email" placeholder="Email del costruttore" /><label for="email">Email</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="cellulare" v-model="formData.costruttore.cellulare" type="text" :state="state.cellulare" placeholder="Numero di cellulare del costruttore" /><label for="cellulare">Cellulare</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="telefono" v-model="formData.costruttore.telefono" type="text" :state="state.telefono" placeholder="Numero del telefono fisso del costruttore" /><label for="telefono">Telefono fisso</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="fax" v-model="formData.costruttore.fax" type="text" :state="state.fax" placeholder="Numero del Fax del costruttore" /><label for="fax">Fax</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="note" v-model="formData.costruttore.note" :state="state.note" rows="3" max-rows="6" /><label for="note">Note</label>
          <br>
        </b-col>
      </b-row>
      <b-row v-if="stato.admin">
        <b-col>
          <b-form-checkbox v-model="formData.costruttore.globale" :value="true" :unchecked-value="false">Rendi il costruttore globale</b-form-checkbox>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col cols="12" md="9" offset-md="1">
          <p>* Campi obbligatori</p>
        </b-col>
        <b-col>        
          <b-button variant="success" size="lg" v-on:click="updateCostruttore()"><font-awesome-icon icon="marker" /> Aggiorna</b-button>
        </b-col>
      </b-row>
      <br>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { globalConf } from '../../../config.global'

var map
var markers

export default {
  name: 'elencocostruttoriedit',
  data() {
    return {
      state: {
        idTipocliente: null,
        denominazione: null,
        cf: null,
        piva: null,
        cont1: null,
        cont2: null,
        website: null,
        email: null,
        cellulare: null,
        telefono: null,
        fax: null,
        note: null,
        search_address: null
      },
      formData:{
        costruttore: {
          denominazione: '',
          cf: '',
          piva: '',
          cont1: '',
          cont2: '',
          via: '',
          civico: '',
          nazione: '',
          provincia: '',
          comune: '',
          cap: '',
          website: '',
          email: '',
          cellulare: '',
          telefono: '',
          fax: '',
          note: '',
          globale: false
        }
      }
    }
  },
  created: function(){
    this.loadCostruttore()
  },
  methods: {
    loadMap(){
      map = new google.maps.Map(document.getElementById('ubicazione_map'), {
        center: {lat: 42.504154, lng: 12.646361},
        streetViewControl: false,
        zoom: 6
      })

      var input = document.getElementById('search_box')
      var searchBox = new google.maps.places.SearchBox(input)
      map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)

      if(this.formData.costruttore.via)
        document.getElementById('search_box').value = this.formData.costruttore.via+", "+this.formData.costruttore.civico+", "+this.formData.costruttore.cap+
                      " "+this.formData.costruttore.comune+" "+this.formData.costruttore.provincia+", "+this.formData.costruttore.nazione

      var localthis = this
      
      var service = new google.maps.places.PlacesService(map);
      
      if(this.formData.costruttore.via){
        var request = {
          query: document.getElementById('search_box').value,
          fields: ['formatted_address', 'geometry', 'html_attributions', 'icon', 'id', 'name', 'place_id', 'plus_code', 'reference', 'types'],
        }

        service.findPlaceFromQuery(request, function(results, status) {
          localthis.setMap(results)
        })
      }

      map.addListener('bounds_changed', function() {
        searchBox.setBounds(map.getBounds())
      })

      markers = []

      searchBox.addListener('places_changed', function() {
        var places = searchBox.getPlaces()

        localthis.setMap(places)
      })
    },
    setMap(places){
      this.state.search_address = null
      var check_msg = this.checkAddress(places)
      if(check_msg != ""){
        Vue.notify({
          group: 'global',
          title: 'Ubicazione errata!',
          text: check_msg,
          type: 'error'
        })
        this.state.search_address = false
        return
      }

      this.setByPlace(places)

      markers.forEach(function(marker) {
        marker.setMap(null)
      })
      markers = []

      var bounds = new google.maps.LatLngBounds()
      places.forEach(function(place) {
        if (!place.geometry) {
          console.log("Returned place contains no geometry")
          return
        }
        var icon = {
          url: place.icon,
          size: new google.maps.Size(71, 71),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25)
        }

        markers.push(new google.maps.Marker({
          map: map,
          icon: icon,
          title: place.name,
          position: place.geometry.location
        }))

        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport)
        } else {
          bounds.extend(place.geometry.location)
        }
      })
      map.fitBounds(bounds)
    },
    checkAddress(places){
      this.formData.costruttore.via = ''
      this.formData.costruttore.civico = ''
      this.formData.costruttore.nazione = ''
      this.formData.costruttore.cap = ''
      this.formData.costruttore.provincia = ''
      this.formData.costruttore.comune = ''

      if(places.length == 0 || places.length > 1){
        return "Assicurati di aver selezionato correttamente la tua ubicazione e di aver selezionato un punto bel preciso!"
      }

      var luogo = places[0].formatted_address

      document.getElementById('search_box').value = luogo
      
      var campi = luogo.split(",")

      if(campi.length != 4){
        return "L'indirizzo inserito non è completo di tutte le informazioni necessarie!"
      }

      if(campi[1].trim().split(" ").length != 1){
        return "Assicurati di aver selezionato correttamente la tua ubicazione e di aver selezionato un punto bel preciso!"
      }

      if(!(campi[3].trim() == "Italia" || campi[3].trim() == "Italy")){
        return "Attualmente sono supportati solo indirizzi italiani! Per qualsiasi dubbio contattare l'assistenza."
      }

      var sub_campi = campi[2].trim().split(" ")

      if(sub_campi.length < 3)
        return "L'indirizzo inserito non è valido!"

      if(isNaN(Number.parseInt(sub_campi[0].trim())))
        return "L'indirizzo inserito non contiene un CAP valido! Riprovare."

      if(sub_campi[sub_campi.length - 1].trim().length != 2)
        return "La provincia inserita non è valida!"

      return ""
    },
    setByPlace(places){
      var luogo = places[0].formatted_address
      console.log(luogo)

      document.getElementById('search_box').value = luogo

      var campi = luogo.split(",")

      this.formData.costruttore.via = campi[0]
      this.formData.costruttore.civico = campi[1]
      this.formData.costruttore.nazione = campi[3] //TODO: se cerco indirizzo fuori italia ho problemi nella formattazione dell'indirizzo

      var sub_campi = campi[2].split(" ")

      this.formData.costruttore.cap = sub_campi[1]
      this.formData.costruttore.provincia = sub_campi[sub_campi.length - 1]
      this.formData.costruttore.comune = sub_campi.slice(2, sub_campi.length - 1).join(" ")
    },
    updateCostruttore(){
      Vue.http.post('elenco/costruttori/update/'+this.$route.params.id, this.formData, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione riuscita!',
            text: 'Costruttore aggiornata con successo!',
            type: 'success'
          })
          this.$router.push('/elenco/costruttori')
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }

          Vue.notify({
              group: 'global',
              title: 'Problemi durante la modifica',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    },
    loadCostruttore(){
      Vue.http.post('elenco/costruttori/load/'+this.$route.params.id, {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.formData = response.body.data

            Vue.loadScript("https://maps.googleapis.com/maps/api/js?key="+globalConf.gmaps+"&libraries=places")
            .then(() => {
              this.loadMap()
            })
            .catch(() => {
              console.log("Errore durante il caricamento di Google Maps!")
            })
        }else{
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
        }
      }, response => {})
    }
  },
  computed: {
    ...mapGetters(['stato'])
  }
}
</script>

<style scoped>
#search_box{
  width: 60%;
  margin-top: 10px;
  margin-left: 20px;
}

#ubicazione_map{
  width: 100%;
  height: 400px;
  border-radius: 4px;

  -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
}

#denominazione{
  text-indent: 155px;
}

#cf{
  text-indent: 140px;
}

#piva{
  text-indent: 110px;
}

#website{
  text-indent: 95px;
}

#cellulare{
  text-indent: 95px;
}

#telefono{
  text-indent: 130px;
}

#fax{
  text-indent: 60px;
}

#note{
  text-indent: 70px;
  line-height: 1.8;
}

#email{
  text-indent: 85px;
}

#cont1{
  text-indent: 105px;
}

#cont2{
  text-indent: 110px;
}
</style>